import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { Box } from '@material-ui/core';
import useStyles from './BoxContainer.styled';

const BoxContainer = ({ children, className, ...props }) => {
  const classes = useStyles();

  return (
    <Box className={clsx(classes.root, className)} {...props}>
      {children}
    </Box>
  );
};

BoxContainer.propTypes = {
  customClasses: PropTypes.any,
  children: PropTypes.node.isRequired,
};

export default BoxContainer;
